import { BaseEntity } from '@/api/EntityApi';
import { AppCurrency, Attachment, Location } from './types';
import { Tag } from '@/api/TagApi';
import { GalleryPhoto } from '@/api/GalleryPhotoApi';

export enum UserStatus {
	INACTIVE = 'INACTIVE',
	ACTIVE = 'ACTIVE',
	SUSPENDED = 'SUSPENDED',
}

export enum UserType {
	ADMIN = 'admin',
	ARTIST = 'artist',
	GALLERY = 'gallery',
}

interface BaseUser extends BaseEntity {
	email: string;
	name: string;
	logo: Attachment | null;
	description: string;
	websiteUrl: string;
	igUrl: string;
	fbUrl: string;
	password: string;
	status: UserStatus;
	userType: UserType;
	cityPlaceId: string;
	location: Location | null;
	tags: Tag[];
	averageRating: number;
	profileViewsCount: number;
}

export interface Admin extends BaseUser {
	userType: UserType.ADMIN;
}

export interface Artist extends BaseUser {
	userType: UserType.ARTIST;
	cityPlaceId: string;
	location: Location | null;
	logo: Attachment | null;
	tags: Tag[];
}

export interface Gallery extends BaseUser {
	userType: UserType.GALLERY;
	address: string;
	vatNumber: string;
	phoneNumber: string;
	registrationDocument: Attachment | null;
	floorPlans: Attachment[];
	mainPhoto?: GalleryPhoto;
	sqm: number;
	rulesAndPracticalInfo: string;
	vatRate: number;
	cityTaxPerDay: number;
	currency: AppCurrency;
}

export type AppUser = Admin;
